<template>
  <div class="van-cell-wrap">
    <van-field :value="value" @click="handleClickSelect()" :label="label" right-icon="arrow" :readonly="true"
               :placeholder="placeholder" :disabled="disabled" :rules="[{ required: required, message: '请选择' }]"/>
    <div></div>
    <van-popup v-model="isPopShow" position="bottom">
      <van-datetime-picker @cancel="isPopShow=false" :min-date="minDate" :max-date="maxDate"
                           @confirm="handleClickConfirm" :formatter="formatter" v-model="selectDate" type="date">
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import {
  formatDate,
  toDate
} from '@/utils/util.js'
import {Dialog} from "vant";

export default {
  name: 'DateField',
  props: {
    label: String,
    value: null,
    minDate: undefined,
    maxDate: undefined,
    readonly: false,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      tpype: String,
      default: '未选择'
    }
  },
  data() {
    return {
      isPopShow: false,
      selectDate: null,
    }
  },
  methods: {
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value;
    },
    handleClickSelect() {
      if (this.readonly) {
        return;
      }
      if (this.value) {
        this.selectDate = toDate(this.value)
      } else if (this.maxDate) {
        this.selectDate = new Date(this.maxDate.getTime())
      } else if (this.minDate) {
        this.selectDate = new Date(this.minDate.getTime())
      }
      this.isPopShow = true
    },
    handleClickConfirm(newValue) {
      this.$emit('input', formatDate(this.selectDate))
      this.isPopShow = false
    }
  }
}
</script>
<style scoped>
</style>
